import Select from 'components/bootstrap/forms/Select';

interface IPCSOSelectErrorProps {
	ariaLabel: string;
}
export const PCSOSelectError = ({ ariaLabel }: IPCSOSelectErrorProps) => {
	return <Select placeholder='Error Occured!' ariaLabel={ariaLabel} />;
};
